import { Decimal } from 'decimal.js';
export var PromotionCreditStatus;
(function (PromotionCreditStatus) {
    PromotionCreditStatus["AVAILABLE"] = "available";
    PromotionCreditStatus["PARTIALLY_USED"] = "partiallyUsed";
    PromotionCreditStatus["USED"] = "used";
    PromotionCreditStatus["EXPIRED"] = "expired";
    PromotionCreditStatus["REVERSED"] = "reversed";
})(PromotionCreditStatus || (PromotionCreditStatus = {}));
/** The derived credit status; an inactive credit with a balance is expired, and `today` is a Pacific date at UTC midnight like `expirationDate`. */
export function derivePromotionCreditStatus(credit, today) {
    if (credit.reversed)
        return PromotionCreditStatus.REVERSED;
    const available = new Decimal(credit.available);
    if (available.isZero())
        return PromotionCreditStatus.USED;
    if (!credit.activeFlag || credit.expirationDate < today)
        return PromotionCreditStatus.EXPIRED;
    if (available.lessThan(credit.amount))
        return PromotionCreditStatus.PARTIALLY_USED;
    return PromotionCreditStatus.AVAILABLE;
}
//# sourceMappingURL=derive-promotion-credit-status.js.map